import { Routes } from './routeConstants'

export type TranslationsList = { [key: string]: string }

export const TRANSLATIONS_NL: TranslationsList = {
    TITLE: 'Inloggen op MyOpen',
    SET_PASSWORD_TITLE: 'Nieuw wachtwoord kiezen',
    FORGOT_PASSWORD_TITLE: 'Wachtwoord vergeten?',
    SET_PASSWORD_SUCCESS: 'Je wachtwoord is opnieuw ingesteld',
    SET_PASSWORD_SEND_LINK: 'Link versturen',
    SET_PASSWORD_SEND_LINK_AGAIN: 'Link opnieuw versturen',
    SET_PASSWORD_BUTTON_TEXT: 'Zet wachtwoord',
    ACTIVATE_ACCOUNT_TITLE: 'Account activeren',
    ACTIVATE_ACCOUNT_ALREADY_ACTIVE_PREFIX: 'Jouw account is al actief.',
    ACTIVATE_ACCOUNT_LOGIN_LINK: 'Klik hier om in te loggen',
    ACTIVATE_ACCOUNT_WELCOME: 'Welkom. Je gaat nu je account activeren. Stel het wachtwoord voor je account in.',
    ACTIVATE_ACCOUNT_RESEND_LINK_BUTTON: 'Stuur nieuwe link',
    ACTIVATE_ACCOUNT_RESEND_HINT:
        'Wanneer je op de knop klikt, wordt er een nieuwe e-mail verstuurd. Gebruik de link in die e-mail om je account te activeren.',
    ACTIVATE_ACCOUNT_LINK_INVALID: 'Deze activatielink is verlopen of niet meer geldig.',
    ACTIVATE_ACCOUNT_MISSING_PARAMS:
        'Deze pagina mist gegevens uit de link. Open de link uit je e-mail opnieuw of vraag een nieuwe activatielink aan.',
    ACTIVATE_ACCOUNT_RESEND_SUCCESS: 'Er is een nieuwe e-mail onderweg. Controleer je inbox.',
    COMPLETE_PASSWORD_RESET_TITLE: 'Nieuw wachtwoord instellen',
    COMPLETE_PASSWORD_RESET_MISSING_PARAMS:
        'Deze pagina mist gegevens uit de link. Open de link uit je e-mail opnieuw of vraag via wachtwoord vergeten een nieuwe link aan.',
    COMPLETE_PASSWORD_RESET_LINK_INVALID: 'Deze link is verlopen of al gebruikt.',
    COMPLETE_PASSWORD_RESET_RESEND_BUTTON: 'Stuur nieuwe link',
    COMPLETE_PASSWORD_RESET_RESEND_HINT:
        'Wanneer je op de knop klikt, wordt er een nieuwe e-mail verstuurd. Gebruik de link in die e-mail om je wachtwoord opnieuw in te stellen.',
    COMPLETE_PASSWORD_RESET_RESEND_SUCCESS: 'Er is een nieuwe e-mail onderweg. Controleer je inbox.',
    MAIL_ADDRESS_LABEL: 'E-mailadres',
    MAIL_REQUIRED_VALIDATION:
        'Vul een geldig e-mailadres in. Op het door jou aangegeven adres ontvang je een link waarmee je een wachtwoord kan instellen.',
    MAIL_HELP_TEXT: 'Vul je e-mailadres in en ontvang een link waarmee je een wachtwoord kan instellen.',
    MAIL_SUCCESS:
        'Als je met dit adres bij ons een account hebt, is de link om je wachtwoord opnieuw in te stellen zojuist verstuurd',
    MAIL_INFO:
        'Na 3 minuten niets ontvangen? Controleer dan het e-mailadres, neem een kijkje in je spamfolder of probeer het opnieuw. Helpt dit niet? Wij zijn bereikbaar op <a href="tel:079 - 760 0685">079 - 760 0685</a>',
    PASSWORD_LABEL: 'Wachtwoord',
    PASSWORD_SHOW: 'Toon',
    PASSWORD_HIDE: 'Verberg',
    PASSWORD_MIN_LENGTH: 'Minimaal 15 tekens',
    PASSWORD_DOES_NOT_MATCH: `Deze combinatie van inloggegevens is bij ons niet bekend. Iets vergeten? <a href="${Routes.RESET_PASSWORD}">Stel je wachtwoord opnieuw in</a>`,
    ERROR_REQUIRED: 'Dit veld is verplicht',
    ERROR_E_MAIL: 'Vul een e-mailadres in',
    LOGIN_BUTTON: 'Inloggen',
    FOOTER_NO_ACCOUNT: 'Nog geen account?',
    FOOTER_REGISTRATION: 'Doe de registratiecheck',
    FOOTER_FORGOT_PASSWORD: 'Wachtwoord vergeten',
    FOOTER_LOGIN_TEXT: 'Inloggen op MyOPEN',
    GENERAL_ERROR_MESSAGE: 'Er is iets fout gegaan, probeer het later nog eens',
    USER_SET_PASSWORD_MESSAGE:
        'Bedankt voor het instellen van je wachtwoord voor de MyOpen app! Om toegang te krijgen tot MyOpen via je smartphone of tablet, moet je deze downloaden op je apparaat. Hier zijn de downloadlinks:',
    USER_LOGGED_IN_MESSAGE: 'Je bent nu ingelogd.',
    EMAIL_CHANGE_CONFIRM_FAIL:
        'Het is niet gelukt je email adres wijziging te bevestigen. Probeer de link opnieuw of neem contact op met Stichting Open.',
    EMAIL_CHANGE_CONFIRM_SUCCESS:
        'Je email adres is succesvol gewijzigd. Je wordt binnen enkele seconden automatisch doorgestuurd naar de login pagina.',
    EMAIL_CHANGE_CONFIRM_TITLE: 'Bevestiging email wijziging',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_EXPIRED':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_USER_IDS_NOT_EQUAL':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_PURPOSE_NOT_EQUALS':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_TOKEN_IS_TRUNCATED':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_SECURITYSTAMP_NOT_EQUALS':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_SECURITYSTAMP_IS_NOT_EMPTY':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_UNHANDELED_EXCEPTION':
        'Deze link is niet meer geldig. Er is een nieuwe link verstuurd naar uw email inbox.',
    'STO.IDENTITY.ERROR.TOKEN_USED':
        'Deze link is al gebruikt. Gebruik alsjeblieft wachtwoord vergeten om je wachtwoord te resetten',
    'STO.IDENTITY.ERROR.PASSWORD_REUSE':
        'Je nieuwe wachtwoord moet verschillen van je huidige wachtwoord',
    PORTAL_SWITCH_TITLE: 'Goedemiddag. Wat wil je gaan doen?',
    PORTAL_SWITCH_SUB_TITLE: 'Je kunt deze keuze later gemakkelijk aanpassen via het menu.',
    PORTAL_SWITCH_OPTION_COLLECTION_TITLE: 'Inzamelen',
    PORTAL_SWITCH_OPTION_COLLECTION_DESCRIPTION:
        'Bekijk en plaats orders om ervoor te zorgen dat inzamelbakken geleegd worden.',
    PORTAL_SWITCH_OPTION_REPORTING_TITLE: 'Opgave doen',
    PORTAL_SWITCH_OPTION_REPORTING_DESCRIPTION: 'Rapporteer welke batterijen je hebt geproduceerd of geïmporteerd.',
    PORTAL_SWITCH_OPTION_ACCOUNT_TITLE: 'Account',
    PORTAL_SWITCH_OPTION_ACCOUNT_DESCRIPTION: 'Beheer de instellingen van je bedrijf.',
    PORTAL_SWITCH_CONTINUE: 'Doorgaan',
    PORTAL_SWITCH_NOT_YET_AVAILABLE: 'Nog niet beschikbaar',
}

export const TRANSLATIONS_EN: TranslationsList = {
    TITLE: 'Log in to MyOpen',
    SET_PASSWORD_TITLE: 'Set new password',
    FORGOT_PASSWORD_TITLE: 'Forgot password?',
    SET_PASSWORD_SUCCESS: 'Your password has been reset',
    SET_PASSWORD_SEND_LINK: 'Send link',
    SET_PASSWORD_SEND_LINK_AGAIN: 'Send link again',
    SET_PASSWORD_BUTTON_TEXT: 'Set password',
    ACTIVATE_ACCOUNT_TITLE: 'Activate account',
    ACTIVATE_ACCOUNT_ALREADY_ACTIVE_PREFIX: 'Your account is already active.',
    ACTIVATE_ACCOUNT_LOGIN_LINK: 'Click here to log in',
    ACTIVATE_ACCOUNT_WELCOME: 'Welcome. You are about to activate your account. Set a password for your account.',
    ACTIVATE_ACCOUNT_RESEND_LINK_BUTTON: 'Send new link',
    ACTIVATE_ACCOUNT_RESEND_HINT:
        'When you click the button, a new email will be sent. Use the link in that email to activate your account.',
    ACTIVATE_ACCOUNT_LINK_INVALID: 'This activation link has expired or is no longer valid.',
    ACTIVATE_ACCOUNT_MISSING_PARAMS:
        'This page is missing details from the link. Open the link from your email again or request a new activation link.',
    ACTIVATE_ACCOUNT_RESEND_SUCCESS: 'A new email is on its way. Check your inbox.',
    COMPLETE_PASSWORD_RESET_TITLE: 'Set new password',
    COMPLETE_PASSWORD_RESET_MISSING_PARAMS:
        'This page is missing details from the link. Open the link from your email again or use forgot password to request a new link.',
    COMPLETE_PASSWORD_RESET_LINK_INVALID: 'This link has expired or has already been used.',
    COMPLETE_PASSWORD_RESET_RESEND_BUTTON: 'Send new link',
    COMPLETE_PASSWORD_RESET_RESEND_HINT:
        'When you click the button, a new email will be sent. Use the link in that email to reset your password.',
    COMPLETE_PASSWORD_RESET_RESEND_SUCCESS: 'A new email is on its way. Check your inbox.',
    MAIL_ADDRESS_LABEL: 'E-mail address',
    MAIL_REQUIRED_VALIDATION:
        'Please enter a valid email address. At the address you specified you will receive a link with which you can set a password.',
    MAIL_HELP_TEXT: 'Enter your email address and receive a link to set a password.',
    MAIL_SUCCESS:
        'If you have an account with us with this address, the link to reset your password has just been sent',
    MAIL_INFO:
        'Dit not receive anything after 3 minutes? Please check the email address, check your spam folder or try again. We can be reached at <a href="tel:079 - 760 0685">079 - 760 0685</a>',
    PASSWORD_LABEL: 'Password',
    PASSWORD_SHOW: 'Show',
    PASSWORD_HIDE: 'Hide',
    PASSWORD_MIN_LENGTH: 'Minimum 15 characters',
    PASSWORD_DOES_NOT_MATCH: `This combination of login details is not known to us. Forget something? <a href="${Routes.RESET_PASSWORD}">Reset your password</a>`,
    ERROR_REQUIRED: 'This field is required',
    ERROR_E_MAIL: 'Enter an e-mail address',
    LOGIN_BUTTON: 'Log in',
    FOOTER_NO_ACCOUNT: 'No account yet?',
    FOOTER_REGISTRATION: 'Check your registration',
    FOOTER_FORGOT_PASSWORD: 'Forgot password',
    FOOTER_LOGIN_TEXT: 'Log in to MyOPEN',
    GENERAL_ERROR_MESSAGE: 'Something went wrong, please try again later',
    USER_SET_PASSWORD_MESSAGE:
        'Thank you for setting your password for the MyOpen app! To access MyOpen on your smartphone or tablet, you need to download it on your device. Here are the download links:',
    USER_LOGGED_IN_MESSAGE: 'You are now logged in.',
    EMAIL_CHANGE_CONFIRM_FAIL:
        'Failed to confirm changing your email address. Try the link again or contact Stichting Open.',
    EMAIL_CHANGE_CONFIRM_SUCCESS:
        'Your email address is successfully updated. In a few seconds you will automatically be redirected to the login page.',
    EMAIL_CHANGE_CONFIRM_TITLE: 'Confirmation email change',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_EXPIRED':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_USER_IDS_NOT_EQUAL':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_PURPOSE_NOT_EQUALS':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_TOKEN_IS_TRUNCATED':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_SECURITYSTAMP_NOT_EQUALS':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_SECURITYSTAMP_IS_NOT_EMPTY':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.USER.VALIDATION.SET_PASSWORD_TOKEN_UNHANDELED_EXCEPTION':
        'This link is no longer valid. You have been sent a new link, please check your email inbox.',
    'STO.IDENTITY.ERROR.TOKEN_USED':
        'This link has already been used. Please use forgot password to reset your password.',
    'STO.IDENTITY.ERROR.PASSWORD_REUSE':
        'Your new password must be different from your current password',
    PORTAL_SWITCH_TITLE: 'Good afternoon. What would you like to do?',
    PORTAL_SWITCH_SUB_TITLE: 'You can easily change this choice later through the menu.',
    PORTAL_SWITCH_OPTION_COLLECTION_TITLE: 'Collection',
    PORTAL_SWITCH_OPTION_COLLECTION_DESCRIPTION: 'View and place orders to ensure that collection bins are emptied.',
    PORTAL_SWITCH_OPTION_REPORTING_TITLE: 'Reporting',
    PORTAL_SWITCH_OPTION_REPORTING_DESCRIPTION: 'Report the batteries you have produced or imported.',
    PORTAL_SWITCH_OPTION_ACCOUNT_TITLE: 'Account',
    PORTAL_SWITCH_OPTION_ACCOUNT_DESCRIPTION: 'Manage your company settings.',
    PORTAL_SWITCH_CONTINUE: 'Continue',
    PORTAL_SWITCH_NOT_YET_AVAILABLE: 'Not yet available',
}
